export type LoadableTrack = string | { source: string; fallbackSource?: string | null };

export type SequenceSourceOption = {
  sources: Array<string>;
  usingFallbackSequence: boolean;
};

export function buildSequencePlan(tracks: Array<LoadableTrack>, sequenceFallbackTracks?: Array<LoadableTrack>) {
  const sources = tracks.map((track) => (typeof track === "string" ? track : track.source));
  const perTrackFallbackSources = tracks.map((track) =>
    typeof track === "string" ? track : (track.fallbackSource ?? track.source),
  );
  const hasPerTrackFallback = perTrackFallbackSources.some((source, index) => source !== sources[index]);
  const sequenceFallbackSources = sequenceFallbackTracks?.map((track) =>
    typeof track === "string" ? track : track.source,
  );
  const sequenceFallbackSecondarySources = sequenceFallbackTracks?.map((track) =>
    typeof track === "string" ? track : (track.fallbackSource ?? track.source),
  );
  const fallbackSourceOptions: Array<SequenceSourceOption> = [
    ...(hasPerTrackFallback ? [{ sources: perTrackFallbackSources, usingFallbackSequence: false }] : []),
    ...(sequenceFallbackSources?.length ? [{ sources: sequenceFallbackSources, usingFallbackSequence: true }] : []),
    ...(sequenceFallbackSecondarySources?.some((source, index) => source !== sequenceFallbackSources?.[index])
      ? [{ sources: sequenceFallbackSecondarySources, usingFallbackSequence: true }]
      : []),
  ];
  const fallbackSequenceId = fallbackSourceOptions.map((option) => option.sources.join("|")).join("::");
  return {
    fallbackSourceOptions,
    sequenceId: fallbackSequenceId ? `${sources.join("|")}::${fallbackSequenceId}` : sources.join("|"),
    sources,
  };
}

export function getLoadSequenceId(tracks: Array<LoadableTrack>, sequenceFallbackTracks?: Array<LoadableTrack>): string {
  return buildSequencePlan(tracks, sequenceFallbackTracks).sequenceId;
}
